import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import {FormattedDate} from 'react-intl';
import CommesseDateCompactView from './CommesseDateCompactView'
import ShowOptionalField from '../ShowOptionalField'
import ShowOptionalLabel from '../ShowOptionalLabel'
import ShowLocalNumber from '../ShowLocalNumber'
import ModalConfirm from '../ModalConfirm'
import {copiaTestoNegliAppunti, getShortText, getCommesseInRendicontazioneDescription} from "../../Helpers";
import ModalCommesseDocumentCreator from './ModalCommesseDocumentCreator';
import {client} from '../../Client';
import LocalDate from "../LocalDate";
import LocalTime from "../LocalTime";

class CommesseTableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    onCopyToClipboard(value){
        copiaTestoNegliAppunti(value);
    }

    render() {
        let c = this.props.commessa
        let copyBtn = null;
        // if (c.pathLocale){
        //     copyBtn = <a className="ui blue icon button" onClick={() => this.onCopyToClipboard(client.adaptClientPath(c.pathLocale))} title="Copia il path locale della commessa sugli appunti">
        //         <i className="copy icon"></i></a>
        // }
        // else {
        //     copyBtn = <a className="ui gray icon button disabled"  title="Path locale non impostato"><i
        //         className="copy icon"
        //     ></i></a>
        // }

        let editBtn = null;
        let deleteBtn = null;
        if (this.props.readOnly == false){
            editBtn = (
                    <Link  className="ui blue icon button" to={`/app/commesse/edit/${c.idCommessa}`}>
                        <i
                            className="edit icon"

                        ></i>
                    </Link>
            );
            deleteBtn = (
                <ModalConfirm
                    msg={"Stai per cancellare la commessa: " + c.nomeCompleto}
                    onClickOk={(ev) => (this.props.onDeleteItem(ev, c))}
                >
                    <a className="ui red icon button"><i className="trash icon"/></a>
                </ModalConfirm>
            );
        }
        let linkToCreaDoc = null;
        if (c.ragioneSociale && client.getCurrentUser().isroledocumentiw){
            linkToCreaDoc = (
                <ModalCommesseDocumentCreator
                    title={"Creazione Documento " + c.nomeCompleto}
                    commessa={c}
                >
                    <a href={"#"}>Crea documento</a>
                </ModalCommesseDocumentCreator>
            )
        }

        let lnkToGara = null;
        if(c.idGara){
            if (client.getCurrentUser().isrolegare){
                lnkToGara = (<Link  className="" to={`/app/gare/edit/${c.idGara.idGara}`}>
                    <div className="sub header">
                        <em>Gara: {c.idGara.anno}/{c.idGara.codice}</em>
                    </div>
                </Link>);
            }else{
                lnkToGara = (<div className="sub header">
                    <em>Gara: {c.idGara.anno}/{c.idGara.codice}</em>
                </div>);
            }
        }

        return (
            <tr>
                <td className="collapsing center aligned">{c.idCommessa}</td>
                <td className="collapsing no-print"><Link to={`/app/commesse/edit/${c.idCommessa}`}><div className="ui segment" style={{backgroundColor: c.colore}}></div></Link></td>
                <td className="collapsing">
                    <Link to={`/app/commesse/edit/${c.idCommessa}`}>{c.codice}</Link>
                    {lnkToGara}
                </td>
                <td className="sorted descending"><Link to={`/app/commesse/edit/${c.idCommessa}`}>{c.nome}</Link>

                    <div className="sub header">
                        {
                            c.oggetto ? <div className="content">
                                {getShortText(c.oggetto, 100) }
                            </div> : null
                        }
                        {
                            c.note ? <div className="content">
                                {c.note}
                            </div> : null
                        }
                        <div className="content">
                            Creato il {c.creatoIl ?  <b><LocalDate data={c.creatoIl } /> <LocalTime data={c.creatoIl } /></b> : <b>?</b>} da <b>{c.creatoDa ? c.creatoDa.username : '?'}</b>&nbsp;
                            Modificato il {c.modificatoIl ?  <b><LocalDate data={c.modificatoIl } /> <LocalTime data={c.modificatoIl } /></b> : <b>?</b>} da <b>{c.modificatoDa ? c.modificatoDa.username : '?'}</b>
                        </div>
                    </div>

                    {/*<CommesseMiniView item={c}/>*/}
                </td>
                <td className="collapsing center aligned">
                    {c.dataIncarico != null ?
                    <FormattedDate
                    value={c.dataIncarico}
                    day="numeric"
                    month="numeric"
                    year="numeric"
                /> : <span></span>
                    }
                </td>
                <td className="center aligned">
                    <CommesseDateCompactView item={c}/>
                </td>
                <td className="">{c.ragioneSociale}
                <div className="sub header">
                    <div>{c.indirizzo} {c.cap} {c.citta} {c.provincia} {c.stato}
                    <ShowOptionalField label="P.IVA" value={c.piva}/> <ShowOptionalField label="C.Fisc." value={c.cfisc}/></div>
                    <ShowOptionalLabel title="FAX"    value={c.fax} icon="fax" extraClassName="left floated"  />
                    <ShowOptionalLabel title="Tel1"    value={c.telefono1} icon="phone" extraClassName="left floated"  />
                    <ShowOptionalLabel title="Tel2"    value={c.telefono2} icon="phone" extraClassName="left floated"  />
                    <ShowOptionalLabel title="Cellulare"    value={c.cellulare} icon="mobile" extraClassName="left floated"  />
                    <ShowOptionalLabel title="e-mail"    value={c.email} icon="mail" extraClassName="left floated"  />
                    <ShowOptionalLabel title="PEC"    value={c.pec} icon="mail" extraClassName="left floated"  />
                    <ShowOptionalLabel title="Web"    value={getShortText(c.web, 30)} icon="world" extraClassName="left floated"  />

                </div>
                    {linkToCreaDoc}
                </td>
                <td className="collapsing center aligned">{c.peso}</td>
                <td className="collapsing center aligned">
                    <ShowLocalNumber value={c.incassoPresunto}/>
                </td>
                <td className="collapsing center aligned">{c.priorita}</td>
                <td className="collapsing center aligned">{c.conclusa ? <label className="ui red rounded label">SI</label> : <label className="ui green rounded label">NO</label>}</td>
                <td className="collapsing center aligned">{c.archiviata ? <label className="ui red rounded label">SI</label> : <label className="ui green rounded label">NO</label>}</td>
                <td className="collapsing center aligned">{getCommesseInRendicontazioneDescription(c.inRendicontazione)}</td>
                <td className="collapsing no-print">
                    {copyBtn}
                    {editBtn}
                    {deleteBtn}
                </td>
            </tr>)
    }
}

export default CommesseTableRow;




/** WEBPACK FOOTER **
 ** ./src/components/commesse/CommesseTableRow.js
 **/